import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex column items-center full-width" }
const _hoisted_2 = { class: "flex flex-center full-width gap-md" }

import translate from 'src/common/helpers/language/translate'
import globalTranslateObject from 'src/translate/global.translate'
import { ref, watchEffect } from 'vue'

interface IProps {
  text: string
  rightButtonLoading?: boolean
  leftButtonLoading?: boolean
  hasWarning?: boolean
  isDeleteModal?: boolean
  icon?: string
  iconColor?: string
  alertIcon?: string
  alertIconColor?: string
  description?: string
  rightButtonLabel?: string
  rightButtonEvent?: string
  leftButtonLabel?: string
  leftButtonEvent?: string
}

type Emits = { [key: string]: never }


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BasePopup' },
  __name: 'BasePopup',
  props: /*@__PURE__*/_mergeModels({
    text: {},
    rightButtonLoading: { type: Boolean, default: false },
    leftButtonLoading: { type: Boolean, default: false },
    hasWarning: { type: Boolean, default: true },
    isDeleteModal: { type: Boolean, default: false },
    icon: { default: '' },
    iconColor: { default: '' },
    alertIcon: { default: 'attention' },
    alertIconColor: { default: 'caution-100' },
    description: { default: '' },
    rightButtonLabel: { default: '' },
    rightButtonEvent: { default: 'add' },
    leftButtonLabel: { default: '' },
    leftButtonEvent: { default: 'cancel' }
  }, {
    "modelValue": { type: Boolean, default: false },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const { t: globalT } = translate(globalTranslateObject)



const model = _useModel(__props, "modelValue")
const props = __props



const rightButtonRef = ref('')
const leftButtonRef = ref('')

watchEffect(() => {
  rightButtonRef.value = !props.rightButtonLabel ? globalT('add') : props.rightButtonLabel
  leftButtonRef.value = !props.leftButtonLabel ? globalT('cancel') : props.leftButtonLabel
})

return (_ctx: any,_cache: any) => {
  const _component_k_alert = _resolveComponent("k-alert")!
  const _component_k_btn = _resolveComponent("k-btn")!
  const _component_k_popup = _resolveComponent("k-popup")!

  return (_openBlock(), _createBlock(_component_k_popup, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model).value = $event)),
    icon: __props.icon,
    "icon-color": __props.iconColor,
    text: __props.text
  }, {
    icon: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon")
    ]),
    actions: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_k_btn, {
          class: "Popup__btn",
          model: "secondary",
          label: leftButtonRef.value,
          size: "md",
          loading: __props.leftButtonLoading,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(__props.leftButtonEvent)))
        }, null, 8, ["label", "loading"]),
        _createVNode(_component_k_btn, {
          class: "Popup__btn",
          model: "primary",
          label: rightButtonRef.value,
          error: __props.isDeleteModal,
          size: "md",
          icon: __props.isDeleteModal && 'trash',
          "is-right-icon": __props.isDeleteModal,
          loading: __props.rightButtonLoading,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$attrs.disable ? '' : _ctx.$emit(__props.rightButtonEvent)))
        }, null, 8, ["label", "error", "icon", "is-right-icon", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.hasWarning && !__props.isDeleteModal && __props.description)
          ? (_openBlock(), _createBlock(_component_k_alert, {
              key: 0,
              model: "warning",
              description: __props.description,
              icon: __props.alertIcon,
              "icon-color": __props.alertIconColor,
              class: "full-width"
            }, null, 8, ["description", "icon", "icon-color"]))
          : (__props.hasWarning && __props.description)
            ? (_openBlock(), _createBlock(_component_k_alert, {
                key: 1,
                model: "error",
                title: "Warning",
                description: __props.description,
                icon: "attention",
                "icon-color": "error-100",
                class: "full-width"
              }, null, 8, ["description"]))
            : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _renderSlot(_ctx.$slots, "content")
    ]),
    _: 3
  }, 8, ["modelValue", "icon", "icon-color", "text"]))
}
}

})